import React from 'react';
import { Motion, spring } from 'react-motion';
import get from 'lodash/get';

import Browser from '../util/Browser';
import Payload from '../util/Payload';
import Celtra from '../util/Celtra';
import CardView from './CardView.react';
import HeaderBar from './HeaderBar.react';

class ContentView extends React.Component {

  static defaultProps = {
    width: 0,
    height: 0,
    open: false,
    currentAdIndex: 0,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentWillMount() {
    const state = {};
    let adsAction = Payload.findAction(this.props.actions, 'queue_interstitial')[0];
    state.ads = adsAction.ads;
    if (typeof adsAction.dismissed !== 'undefined' && adsAction.dismissed.type === 'ad_deeplink') {
      state.dismissedUrl = adsAction.dismissed.url;
    }
    this.setState(state);
    return true;
  }

  componentDidMount() {
    window.server.logForImprIds('ContentView_mounted');
    this.setState({ backgroundColor: this.getHeaderColor() });
    this.updateScreen(this.props);

    this.setIsCeltra(Celtra.isCeltra({ ad: get(this.state, this.currentAdGetString(), {}) }, ''));
  }

  componentWillUpdate(nextProps, nextState) {
    const { height } = this.props;

    // seemed like we'd want this loaded prior to the update
    // it wasn't loading in EngagementApp.componentWillMount
    // due to that being called so far in advance of an engagement
    // on the actual devices.
    const queueInterstitial = Payload.findAction(get(nextProps, 'actions', []), 'queue_interstitial');
    if (window.injectOmSdkVerificationScript &&
      queueInterstitial[0] &&
      queueInterstitial[0].omSdkVerify &&
      queueInterstitial[0].omSdkVerify === true
    ) {
      window.injectOmSdkVerificationScript();
    }

    if (nextProps.height > 0 && height !== nextProps.height) {
      console.warn('ContentView - calling updateScreen');
      this.updateScreen(nextProps);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { didFinishHide, open } = this.props;
    const { dismissedUrl } = this.state;
    if (prevProps.open && !open) {
      console.warn('ContentView - calling didFinishHide');
      didFinishHide(dismissedUrl);
    }
  }

  getInitialState = () => ({
    isCeltra: false,
    modalModel: {
      state: 'hidden',
      forCard: false,
      src: false,
    },
    onRest: false,
    initialHeight: 1000,
    originalOffset: null,
    dismissedUrl: null,
    ads: null,
    cardViewState: null,
    headerBarState: null,
  });

  currentAdGetString = () => `ads[${this.props.currentAdIndex}]`;

  updateScreen = nextProps => {
    console.log(`[E2]: adjust ad card size height: ${nextProps.height}, width: ${nextProps.width}`);
    const viewportSize = {
      width: nextProps.width,
      height: nextProps.height,
    };

    const headerHeight = Browser.getHeaderHeight();
    const defaultWidth = nextProps.width;
    const headerWidth = defaultWidth;
    const aspectRatio = 503 / 320;
    const maxSize = {
      height: viewportSize.height - headerHeight,
      width: viewportSize.width,
    };

    // Set Card dimensions, scale based on viewport & Card size.
    const ad = get(this.state, this.currentAdGetString());

    // Set headerbar dimensions & bgcolor.
    const headerBarState = {
      width: headerWidth,
      height: headerHeight,
      backgroundColor: this.getHeaderColor(),
      adChoices: ad.adChoices || false,
    };

    let cardViewState = {};
    if (typeof ad === 'object' && nextProps.width > 0 && nextProps.height > 0) {
      // Get Card dimensions
      const adSize = {
        width: ad.width || defaultWidth,
        height: ad.height || defaultWidth * aspectRatio,
      };
      const cardSize = this.getCardSize(maxSize, viewportSize, adSize);
      // Check if ad is out of viewport, adjust.
      const { maxWidth, left, frameScale, width, height, maxHeight, percentViewable } = cardSize;
      cardViewState = {
        height,
        width,
        widthOrig: adSize.width,
        heightOrig: adSize.height - Browser.getTopPadding(),
        paddingTop: headerHeight,
        maxHeight,
        maxWidth,
        frameScale,
        left,
        percentViewable,
        viewportSize,
        scrollable: ad.scrollable || false,
        preview: ad.preview || false,
      };
    }

    this.setState({ cardViewState, headerBarState });
  };

  onRest = () => {
    this.setState({
      onRest: true,
    });
  };

  getCardSize = (maxSize, viewportSize, adSize, headerHeight) => {
    const defaultCardAspectRatio =
      adSize.width && adSize.height ? adSize.height / adSize.width : 503 / 320;
    const defaultCardWidth = adSize.width || maxSize.width;
    const defaultCardHeight = adSize.width * defaultCardAspectRatio;
    const cardWidth = maxSize.width;
    const cardHeight = defaultCardAspectRatio * maxSize.width;
    let percentViewable = 100;
    let left = 0;
    let frameScale = cardWidth / defaultCardWidth || 0;
    let maxHeight = maxSize.height;
    let maxWidth = maxSize.width;

    // Detect if iframe height is out of viewport, adjust to be 100% in viewport.
    if (cardWidth > 0 && cardHeight > 0) {
      const iframePosition = this.getPercentInViewport(cardWidth, cardHeight, maxSize);
      if (iframePosition.percent !== 100) {
        // Adjust styles.
        percentViewable = iframePosition.percent;
        // Scale width and height, floor decimals on height and leave decimals on width.
        const scalePercent = percentViewable * 0.01;
        maxHeight = Math.floor(cardHeight * scalePercent);
        maxWidth = cardWidth * (maxHeight / cardHeight);
        frameScale *= scalePercent;
        left = `${(viewportSize.width - maxWidth) / 2}px`;
      }
    }
    return {
      width: cardWidth,
      height: cardHeight,
      widthOrig: defaultCardWidth,
      heightOrig: defaultCardHeight - Browser.getTopPadding(),
      maxHeight,
      maxWidth,
      frameScale: `scale(${frameScale})`,
      percentViewable,
      left,
    };
  };

  // get color of header bar and make available to both HeaderBar and SliderView.
  getHeaderColor = () => {
    if (
      this.props.fields &&
      this.props.fields.publisher &&
      this.props.fields.publisher.engagement_header_color
    ) {
      return this.props.fields.publisher.engagement_header_color;
    }
    return '#434343';
  };

  getPercentInViewport = (cardWidth, cardHeight, maxSize) => {
    const cutOffX = cardWidth - maxSize.width;
    const cutOffY = cardHeight - maxSize.height;
    const adArea = cardWidth * cardHeight;
    let percentViewable = 1;
    if (cutOffX > 0 && cutOffY > 0) {
      const viewportArea = window.innerWidth * window.innerHeight;
      percentViewable = viewportArea / adArea;
    } else if (cutOffX > 0 || cutOffY > 0) {
      percentViewable =
        cutOffX > 0 ? 1 - (cardHeight * cutOffX) / adArea : 1 - (cardWidth * cutOffY) / adArea;
    }
    return {
      cutOffX,
      cutOffY,
      percent: percentViewable * 100,
    };
  };

  enableModal = (forCard, src) => {
    this.setState({
      modalModel: {
        forCard,
        src,
        state: 'show',
      },
    });
  };

  disableModal = () => {
    this.setState({
      modalModel: {
        forCard: false,
        src: false,
        state: 'hide',
      },
    });
  };

  setModalHidden = () => {
    this.setState({
      modalModel: {
        forCard: false,
        src: false,
        state: 'hidden',
      },
    });
  };

  setIsCeltra = json => {
    this.setState({ isCeltra: json });
  };

  render() {
    const { isReadyToOpen, didFinishLoad, doClose, fields, height, open, width, currentAdIndex, adsControl } = this.props;
    // setting contentView size
    const contentNodeStyle = {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      height: '100%',
      width: '100%',
      zIndex: 200,
      position: 'fixed !important',
      overflow: 'hidden',
    };

    const { onRest: onRest1, headerBarState, cardViewState, modalModel, isCeltra } = this.state;
    const header = (
      <HeaderBar
        isCeltra={isCeltra}
        ad={get(this.state, this.currentAdGetString(), {})}
        adsControl={adsControl}
        doClose={doClose}
        headerBarState={headerBarState}
        fields={fields}
        enableModal={this.enableModal}
        disableModal={this.disableModal}
        modalModel={modalModel}
        didFinishAnimation={onRest1}
        />
    );
    return (
      <div id={`contentNode${isCeltra ? 'Celtra' : ''}`} style={contentNodeStyle}>
        <Motion
          defaultStyle={{ y: currentAdIndex > 0 ? 0 : this.state.initialHeight }}
          style={{ y: spring(open ? 0 : height) }}
          onRest={this.onRest}
        >
          {({ y }) => (
            // children is a callback which should accept the current value of
            // `style`
            <div>
              {isCeltra ? header : ''}
              <div
                id="container"
                style={{
                  WebkitTransform: `translate3d(0, ${y}px, 0px)`,
                  transform: `translate3d(0, ${y}px, 0px)`,
                  position: `relative`,
                  // when celtra busts out of the frame, it's z-index is 2147483645
                  // so we want this div beneath that.
                  zIndex: isCeltra ? Celtra.constants.maxZIndex - 1 : 'inherit',
                }}
              >
                {isCeltra ? '' : header}
                <CardView
                  setIsCeltra={this.setIsCeltra}
                  fetchJson={get(this.props, `${this.currentAdGetString()}.fetchJson`, true)}
                  ad={get(this.state, this.currentAdGetString(), {})}
                  {...fields}
                  cardViewState={cardViewState}
                  setModalHidden={this.setModalHidden}
                  enableModal={this.enableModal}
                  disableModal={this.disableModal}
                  modalModel={modalModel}
                  didFinishLoad={didFinishLoad}
                  componentName="Card_0"
                  open={open}
                  adsControl={adsControl}
                  isReadyToOpen={isReadyToOpen}
                  didFinishAnimation={onRest1}
                />
              </div>
            </div>
          )}
        </Motion>
      </div>
    );
  }
}

export default ContentView;
